export class AppSettings {


      //////// LOCAL /////////////////////////
       // lhcsaAPI = 'http://localhost:61857';
       // onBaseServer = 'https://phcobapptest.premierhomehealthcare.com/appnet';
       // enrollServer = 'http://localhost:4201';


      //////// LOCAL /////////////////////////
       //lhcsaAPI = 'http://localhost:60096';
       //onBaseServer = 'https://phcobapptest.premierhomehealthcare.com/appnet';
       //enrollServer = 'http://localhost:4201';

      //////// DEV /////////////////////////
      //lhcsaAPI = 'https://lhcsapidev.premierhomehealthcare.com';
      //onBaseServer = 'https://phcobapptest.premierhomehealthcare.com/appnet'; // ONBASE CONFIG VALUE NOT NEEDED IN THIS APP ANYMORE
      //enrollServer = 'https://applicationdev.premierhomehealthcare.com';

      //////// DEV new/////////////////////////
       //lhcsaAPI = 'https://lhcsapidev.premierhomehealthcare.com';
       //onBaseServer = 'https://phcobapptest.premierhomehealthcare.com/appnet'; // ONBASE CONFIG VALUE NOT NEEDED IN THIS APP ANYMORE
       //enrollServer = 'https://applicationdev.premierhomehealthcare.com';

      //////// PROD /////////////////////////
      
      lhcsaAPI = 'https://lhcsapi.premierhomehealthcare.com';
                //onBaseServer = 'https://phconbaseapp.premierhomehealthcare.com/appnetob';
      onBaseServer = 'https://phcobapptest.premierhomehealthcare.com/appnet';
      enrollServer = 'https://application.premierhomehealthcare.com';
      
}

  // ng serve -o --port 4201
  // ng build --prod